import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMapSigns as falMapSigns,
  faCommentAlt as falCommentAlt,
  faCommentsAlt as falCommentsAlt,
  faCheck as falCheck,
  faUserAlt as falUserAlt,
  faStar as falStar,
  faCheckCircle as falCheckCircle,
  faSearch as falSearch,
  faAngleUp as falAngleUp,
  faAngleDown as falAngleDown,
  faAngleLeft as falAngleLeft,
  faAngleRight as falAngleRight,
  faChevronUp as falChevronUp,
  faChevronDown as falChevronDown,
  faChevronLeft as falChevronLeft,
  faChevronRight as falChevronRight,
  faChevronDoubleLeft as falChevronDoubleLeft,
  faChevronDoubleRight as falChevronDoubleRight,
  faExclamationCircle as falExclamationCircle,
  faExclamationTriangle as falExclamationTriangle,
  faCars as falCars,
  faCaravanAlt as falCaravanAlt,
  faCarWash as falCarWash,
  faCarCrash as falCarCrash,
  faCarAlt as falCarAlt,
  faCalendarAlt as falCalendarAlt,
  faCog as falCog,
  faBook as falBook,
  faBars as falBars,
  faArrowLeft as falArrowLeft,
  faArrowRight as falArrowRight,
  faArrowUp as falArrowUp,
  faArrowDown as falArrowDown,
  faInfoCircle as falInfoCircle,
  faTimes as falTimes,
  faPoundSign as falPoundSign,
  faGavel as falGavel,
  faChargingStation as falChargingStation,
  faGasPump as falGasPump,
  faBellSlash as falBellSlash,
  faBell as falBell,
  faTruckMoving as falTruckMoving,
  faTruckPickup as falTruckPickup,
  faTruckContainer as falTruckContainer,
  faCarSide as falCarSide,
  faCarMechanic as falCarMechanic,
  faCarGarage as falCarGarage,
  faCar as falCar,
  faTire as falTire,
  faRoad as falRoad,
  faPhoneAlt as falPhoneAlt,
  faDesktop as falDesktop,
  faMobile as falMobile,
  faTv as falTv,
  faAward as falAward,
  faBullseye as falBullseye,
  faClipboardListCheck as falClipboardListCheck,
  faClipboardList as falClipboardList,
  faCalendarCheck as falCalendarCheck,
  faBookmark as falBookmark,
  faBallotCheck as falBallotCheck,
  faBallot as falBallot,
  faAddressBook as falAddressBook,
  faBan as falBan,
  faPlus as falPlus,
  faSignOut as falSignOut,
  faStickyNote as falStickyNote,
  faTruck as falTruck,
  faMotorcycle as falMotorcycle,
  faMapMarker as falMapMarker,
  faPlay as falPlay,
  faTrash as falTrash,
  faFilter as falFilter,
  faFileCertificate as falFileCertificate,
  faHistory as falHistory,
  faWrench as falWrench,
  faTachometerFast as falTachometerFast,
  faUsers as falUsers,
  faChartLine as falChartLine,
  faEnvelope as falEnvelope,
} from "@fortawesome/pro-light-svg-icons";
import {
  faMapSigns as farMapSigns,
  faCommentAlt as farCommentAlt,
  faCommentsAlt as farCommentsAlt,
  faCheck as farCheck,
  faUserAlt as farUserAlt,
  faStar as farStar,
  faCheckCircle as farCheckCircle,
  faSearch as farSearch,
  faAngleUp as farAngleUp,
  faAngleDown as farAngleDown,
  faAngleLeft as farAngleLeft,
  faAngleRight as farAngleRight,
  faChevronUp as farChevronUp,
  faChevronDown as farChevronDown,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faChevronDoubleLeft as farChevronDoubleLeft,
  faChevronDoubleRight as farChevronDoubleRight,
  faExclamationCircle as farExclamationCircle,
  faExclamationTriangle as farExclamationTriangle,
  faCars as farCars,
  faCaravanAlt as farCaravanAlt,
  faCarWash as farCarWash,
  faCarCrash as farCarCrash,
  faCarAlt as farCarAlt,
  faCalendarAlt as farCalendarAlt,
  faCog as farCog,
  faBook as farBook,
  faBars as farBars,
  faArrowLeft as farArrowLeft,
  faArrowRight as farArrowRight,
  faArrowUp as farArrowUp,
  faArrowDown as farArrowDown,
  faInfoCircle as farInfoCircle,
  faTimes as farTimes,
  faPoundSign as farPoundSign,
  faGavel as farGavel,
  faChargingStation as farChargingStation,
  faGasPump as farGasPump,
  faBellSlash as farBellSlash,
  faBell as farBell,
  faTruckMoving as farTruckMoving,
  faTruckPickup as farTruckPickup,
  faTruckContainer as farTruckContainer,
  faCarSide as farCarSide,
  faCarMechanic as farCarMechanic,
  faCarGarage as farCarGarage,
  faCar as farCar,
  faTire as farTire,
  faRoad as farRoad,
  faPhoneAlt as farPhoneAlt,
  faDesktop as farDesktop,
  faMobile as farMobile,
  faTv as farTv,
  faAward as farAward,
  faBullseye as farBullseye,
  faClipboardListCheck as farClipboardListCheck,
  faClipboardList as farClipboardList,
  faCalendarCheck as farCalendarCheck,
  faBookmark as farBookmark,
  faBallotCheck as farBallotCheck,
  faBallot as farBallot,
  faAddressBook as farAddressBook,
  faBan as farBan,
  faPlus as farPlus,
  faSignOut as farSignOut,
  faStickyNote as farStickyNote,
  faTruck as farTruck,
  faMotorcycle as farMotorcycle,
  faMapMarker as farMapMarker,
  faPlay as farPlay,
  faTrash as farTrash,
  faFilter as farFilter,
  faFileCertificate as farFileCertificate,
  faHistory as farHistory,
  faWrench as farWrench,
  faTachometerFast as farTachometerFast,
  faUsers as farUsers,
  faChartLine as farChartLine,
  faEnvelope as farEnvelope,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faMapSigns as fasMapSigns,
  faCommentAlt as fasCommentAlt,
  faCommentsAlt as fasCommentsAlt,
  faCheck as fasCheck,
  faUserAlt as fasUserAlt,
  faStar as fasStar,
  faCheckCircle as fasCheckCircle,
  faSearch as fasSearch,
  faAngleUp as fasAngleUp,
  faAngleDown as fasAngleDown,
  faAngleLeft as fasAngleLeft,
  faAngleRight as fasAngleRight,
  faChevronUp as fasChevronUp,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronDoubleLeft as fasChevronDoubleLeft,
  faChevronDoubleRight as fasChevronDoubleRight,
  faExclamationCircle as fasExclamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faCars as fasCars,
  faCaravanAlt as fasCaravanAlt,
  faCarWash as fasCarWash,
  faCarCrash as fasCarCrash,
  faCarAlt as fasCarAlt,
  faCalendarAlt as fasCalendarAlt,
  faCog as fasCog,
  faBook as fasBook,
  faBars as fasBars,
  faArrowLeft as fasArrowLeft,
  faArrowRight as fasArrowRight,
  faArrowUp as fasArrowUp,
  faArrowDown as fasArrowDown,
  faInfoCircle as fasInfoCircle,
  faTimes as fasTimes,
  faPoundSign as fasPoundSign,
  faGavel as fasGavel,
  faChargingStation as fasChargingStation,
  faGasPump as fasGasPump,
  faBellSlash as fasBellSlash,
  faBell as fasBell,
  faTruckMoving as fasTruckMoving,
  faTruckPickup as fasTruckPickup,
  faTruckContainer as fasTruckContainer,
  faCarSide as fasCarSide,
  faCarMechanic as fasCarMechanic,
  faCarGarage as fasCarGarage,
  faCar as fasCar,
  faTire as fasTire,
  faRoad as fasRoad,
  faPhoneAlt as fasPhoneAlt,
  faDesktop as fasDesktop,
  faMobile as fasMobile,
  faTv as fasTv,
  faAward as fasAward,
  faBullseye as fasBullseye,
  faClipboardListCheck as fasClipboardListCheck,
  faClipboardList as fasClipboardList,
  faCalendarCheck as fasCalendarCheck,
  faBookmark as fasBookmark,
  faBallotCheck as fasBallotCheck,
  faBallot as fasBallot,
  faAddressBook as fasAddressBook,
  faBan as fasBan,
  faPlus as fasPlus,
  faSignOut as fasSignOut,
  faStickyNote as fasStickyNote,
  faTruck as fasTruck,
  faMotorcycle as fasMotorcycle,
  faMapMarker as fasMapMarker,
  faPlay as fasPlay,
  faTrash as fasTrash,
  faFilter as fasFilter,
  faFileCertificate as fasFileCertificate,
  faHistory as fasHistory,
  faWrench as fasWrench,
  faTachometerFast as fasTachometerFast,
  faUsers as fasUsers,
  faChartLine as fasChartLine,
  faEnvelope as fasEnvelope,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faTwitter as fabTwitter,
  faLinkedinIn as fabLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  falMapSigns,
  falCommentAlt,
  falCommentsAlt,
  falCheck,
  falUserAlt,
  falStar,
  falCheckCircle,
  falSearch,
  falAngleUp,
  falAngleDown,
  falAngleLeft,
  falAngleRight,
  falChevronUp,
  falChevronDown,
  falChevronRight,
  falChevronLeft,
  falChevronDoubleLeft,
  falChevronDoubleRight,
  falExclamationCircle,
  falExclamationTriangle,
  falCars,
  falCaravanAlt,
  falCarWash,
  falCarCrash,
  falCarAlt,
  falCalendarAlt,
  falCog,
  falBook,
  falBars,
  falArrowLeft,
  falArrowRight,
  falArrowUp,
  falArrowDown,
  falInfoCircle,
  falTimes,
  falPoundSign,
  falGavel,
  falChargingStation,
  falGasPump,
  falBellSlash,
  falBell,
  falTruckMoving,
  falTruckPickup,
  falTruckContainer,
  falCarSide,
  falCarMechanic,
  falCarGarage,
  falCar,
  falTire,
  falRoad,
  falPhoneAlt,
  falDesktop,
  falMobile,
  falTv,
  falAward,
  falBullseye,
  falClipboardListCheck,
  falClipboardList,
  falCalendarCheck,
  falBookmark,
  falBallotCheck,
  falBallot,
  falAddressBook,
  falBan,
  falPlus,
  falSignOut,
  falStickyNote,
  falTruck,
  falMotorcycle,
  falMapMarker,
  falPlay,
  falTrash,
  falFilter,
  falFileCertificate,
  falHistory,
  falWrench,
  falTachometerFast,
  falUsers,
  falChartLine,
  falEnvelope,
  farMapSigns,
  farCommentAlt,
  farMapSigns,
  farCommentAlt,
  farCommentsAlt,
  farCheck,
  farUserAlt,
  farStar,
  farCheckCircle,
  farSearch,
  farAngleUp,
  farAngleDown,
  farAngleLeft,
  farAngleRight,
  farChevronUp,
  farChevronDown,
  farChevronLeft,
  farChevronRight,
  farChevronDoubleLeft,
  farChevronDoubleRight,
  farExclamationCircle,
  farExclamationTriangle,
  farCars,
  farCaravanAlt,
  farCarWash,
  farCarCrash,
  farCarAlt,
  farCalendarAlt,
  farCog,
  farBook,
  farBars,
  farArrowLeft,
  farArrowRight,
  farArrowUp,
  farArrowDown,
  farInfoCircle,
  farTimes,
  farPoundSign,
  farGavel,
  farChargingStation,
  farGasPump,
  farBellSlash,
  farBell,
  farTruckMoving,
  farTruckPickup,
  farTruckContainer,
  farCarSide,
  farCarMechanic,
  farCarGarage,
  farCar,
  farTire,
  farRoad,
  farPhoneAlt,
  farDesktop,
  farMobile,
  farTv,
  farAward,
  farBullseye,
  farClipboardListCheck,
  farClipboardList,
  farCalendarCheck,
  farBookmark,
  farBallotCheck,
  farBallot,
  farAddressBook,
  farBan,
  farPlus,
  farSignOut,
  farStickyNote,
  farTruck,
  farMotorcycle,
  farMapMarker,
  farPlay,
  farTrash,
  farFilter,
  farFileCertificate,
  farHistory,
  farWrench,
  farTachometerFast,
  farUsers,
  farChartLine,
  farEnvelope,
  fasMapSigns,
  fasCommentAlt,
  fasMapSigns,
  fasCommentAlt,
  fasCommentsAlt,
  fasCheck,
  fasUserAlt,
  fasStar,
  fasCheckCircle,
  fasSearch,
  fasAngleUp,
  fasAngleDown,
  fasAngleLeft,
  fasAngleRight,
  fasChevronUp,
  fasChevronDown,
  fasChevronLeft,
  fasChevronRight,
  fasChevronDoubleLeft,
  fasChevronDoubleRight,
  fasExclamationCircle,
  fasExclamationTriangle,
  fasCars,
  fasCaravanAlt,
  fasCarWash,
  fasCarCrash,
  fasCarAlt,
  fasCalendarAlt,
  fasCog,
  fasBook,
  fasBars,
  fasArrowLeft,
  fasArrowRight,
  fasArrowUp,
  fasArrowDown,
  fasInfoCircle,
  fasTimes,
  fasPoundSign,
  fasGavel,
  fasChargingStation,
  fasGasPump,
  fasBellSlash,
  fasBell,
  fasTruckMoving,
  fasTruckPickup,
  fasTruckContainer,
  fasCarSide,
  fasCarMechanic,
  fasCarGarage,
  fasCar,
  fasTire,
  fasRoad,
  fasPhoneAlt,
  fasDesktop,
  fasMobile,
  fasTv,
  fasAward,
  fasBullseye,
  fasClipboardListCheck,
  fasClipboardList,
  fasCalendarCheck,
  fasBookmark,
  fasBallotCheck,
  fasBallot,
  fasAddressBook,
  fasBan,
  fasPlus,
  fasSignOut,
  fasStickyNote,
  fasTruck,
  fasMotorcycle,
  fasMapMarker,
  fasPlay,
  fasTrash,
  fasFilter,
  fasFileCertificate,
  fasHistory,
  fasWrench,
  fasTachometerFast,
  fasUsers,
  fasChartLine,
  fasEnvelope,
  fabTwitter,
  fabLinkedinIn
);
